import {
  LOAD_NON_VIOLATION_RESULTS_REQUEST,
  LOAD_NON_VIOLATION_RESULTS_SUCCESS,
  LOAD_NON_VIOLATION_RESULTS_FAILURE,
  RESET_NON_VIOLATION_RESULTS,
} from '../../config/actions';

// Initial state for non-violation results
const initialState = {
  passes: {
    data: null,
    loading: false,
    error: null
  },
  incomplete: {
    data: null,
    loading: false,
    error: null
  },
  inapplicable: {
    data: null,
    loading: false,
    error: null
  }
};

/**
 * Reducer for managing non-violation axe results state
 * Handles loading, success, and error states for passes, incomplete, and inapplicable results
 */
export default (state = initialState, action) => {
  const { type, payload } = action;
  
  switch (type) {
    case LOAD_NON_VIOLATION_RESULTS_REQUEST:
      return {
        ...state,
        [payload.resultType]: {
          ...state[payload.resultType],
          loading: true,
          error: null
        }
      };

    case LOAD_NON_VIOLATION_RESULTS_SUCCESS:
      return {
        ...state,
        [payload.resultType]: {
          data: payload.data,
          loading: false,
          error: null
        }
      };

    case LOAD_NON_VIOLATION_RESULTS_FAILURE:
      return {
        ...state,
        [payload.resultType]: {
          ...state[payload.resultType],
          loading: false,
          error: payload.error
        }
      };

    case RESET_NON_VIOLATION_RESULTS:
      return initialState;

    default:
      return state;
  }
};
